function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "52.348%",
  x2: "52.348%",
  y1: "74.611%",
  y2: "-17.635%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEDEDE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A9A9A9",
  stopOpacity: 0.3
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "44.79%",
  x2: "44.79%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#96A1C5",
  stopOpacity: 0.373
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "-19.675%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#919191",
  stopOpacity: 0.15
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "44.95%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5389F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#416FDC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: "63.345%",
  x2: "63.345%",
  y1: "100%",
  y2: "-5.316%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DCE9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#B6CFFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7CA5F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C4D6FC"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1.866 .364)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M27.94 14.86c1.33-4.19 2.56-6.8 3.7-7.83 3.16-2.84 7.52-1.3 8.45-1.07 3.26.78 2.2-4.37 5-5.41 1.86-.7 3.4.15 4.6 2.55C50.75.86 52.38-.16 54.56.02c3.27.28 4.41 11.33 8.9 8.9 4.5-2.41 10.02-2.96 12.37.63.51.78.7-.43 4.17-4.55C83.46.88 86.91-.94 94 1.46c3.22 1.1 5.86 4.05 7.94 8.87 0 6.88 5.06 10.95 15.18 12.21 15.18 1.9 3.4 18.21-15.18 23-18.57 4.77-61.34 7.35-84.55-4.72-15.47-8.05-11.95-16.7 10.55-25.96z",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 66,
  cy: 69.166,
  fill: "url(#b)",
  rx: 27.987,
  ry: 6.478
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M113.25 77.25c-21.04 5.28-92.87-.76-100.52-3.52-3.72-1.34-7.07-3.87-10.06-7.57a2.82 2.82 0 012.2-4.6H130.4c2.6 6.94-3.11 12.17-17.14 15.69z",
  opacity: 0.675
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M43.4 12.1L33.83.9a2.43 2.43 0 00-1.84-.85H11.4c-.7 0-1.38.32-1.84.86L0 12.1v6.14h43.4V12.1z",
  transform: "translate(44.08 39.707)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M40.68 18.47l-8.37-9.75A2.14 2.14 0 0030.68 8H12.72c-.62 0-1.22.25-1.62.72L2.7 18.47v5.35h37.97v-5.35z",
  transform: "translate(44.08 39.707)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M43.4 25.28a2.8 2.8 0 01-1 2.14l-.12.1a2.76 2.76 0 01-1.67.56H2.78c-.34 0-.67-.06-.97-.18l-.15-.06A2.8 2.8 0 010 25.28V12.16h10.53c1.16 0 2.1.96 2.1 2.12v.02c0 1.16.95 2.1 2.11 2.1h13.92a2.11 2.11 0 002.1-2.11c0-1.17.94-2.13 2.1-2.13H43.4z",
  transform: "translate(44.08 39.707)"
})));

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.7e6338c5.svg";
export { ForwardRef as ReactComponent };